export const USER_PROFILE_TAB_BUILDINGS_SCOPE_FILTER_KEY = 'staff_member'

export const USER_PROFILE_TAB_BUILDINGS_QA_NAME = {
  addNew: 'userProfileTabBuildingsAddNew',
  editBuildings: 'userProfileTabBuildingsEdit',
  table: 'userProfileTabBuildings',
}
